<template>
	<div class="test_result_structure">
		<pre class="doc_main_pre"><code class="doc_main_code">// 检测结果结构体
public class FaceStruct {
    public int FaceRX1; // 人脸矩形左上点X
    public int FaceRY1; // 人脸矩形左上点Y
    public int FaceRX2; // 人脸矩形右上点X
    public int FaceRY2; // 人脸矩形右上点Y
    public int FaceRX3; // 人脸矩形右下点X
    public int FaceRY3; // 人脸矩形右下点Y
    public int FaceRX4; // 人脸矩形左下点X
    public int FaceRY4; // 人脸矩形左下点Y
    public int FaceRectSX; // 人脸正方形起始X
    public int FaceRectSY; // 人脸正方形起始Y
    public int FaceSize; // 人脸正方形边长
    public int TrackID; // 人脸跟踪ID[随机值主要使用于跟踪标记]
    public float ImageQuality; // 人脸图像品质0.0-1.0f  >0.7 进行人脸特征提取有效
    public int Update; // 人脸图像可识别更新情况 , 主要用于人脸跟踪. 0 不建议更新  1 建议更新
    public int Pitch;  // 抬头低头欧拉角(-90  -  90)  -30 - 30 度范围进行人脸特征提取有效
    public int Roll; // 面内旋转欧拉角(-180 - 180)   360全角度进行人脸特征提取有效
    public int Yaw; // 左右转动欧拉角(-90  -  90)  -45 - 45度范围进行人脸特征提取有效
    public int FaceDistance;//人脸距离（<0则表示无效（未检测到距离））
    public int IsTalking; // 0 没有说话 1 正在说话
    public String PersonID; // 人员ID
    public String Name;//姓名
    public int Age; // 年龄 <=0 表示不清楚
    public int Sex; // 性别 0 不清楚 1 女性 2 男性
    public int Glasses; // 0 不戴眼镜 1 戴眼镜 2 太阳镜 <0 表示不清楚
    public String Feature; //【废弃】人脸特征值，字符串
    public byte[] BinFeature;//人脸特征值，byte数组
    public float KeyPoint[];  // 人脸形状关键点信息72个关键点，先x后y【企业版提供】
};
</code></pre>
	</div>
</template>
<script>
	export default{
		// props: {
  //           pathData:null,
  //       },
		data(){
			return{
				
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){
			
		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../less/index.less';
	.test_result_structure{
		
	}
</style>	


// WEBPACK FOOTER //
// src/components/DetectionStructuralArray.vue